import { Component, Input, OnInit } from '@angular/core';
import {VERSION} from 'app/app.constants';
import {ConfigurazioneGeneraleService} from "../../services/configurazione-generale.service";
import {Configurazione} from "../../models/configurazione";
import {filter} from "rxjs/operators";
import {take} from "rxjs";
import {DomSanitizer} from "@angular/platform-browser";
import { HomePageHeaderFooter } from '../../models/home-page-header-footer.model';
@Component({
  selector: 'jhi-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  configurazione!: Configurazione;
  logoImage!: any;
  @Input() homePageHeaderFooter?: HomePageHeaderFooter;
  protected readonly VERSION = VERSION;

  constructor(private confService: ConfigurazioneGeneraleService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.confService.configurazione$
      .pipe(filter(configurazione => configurazione !== null), take(1))
      .subscribe(configurazione => {
        this.configurazione = configurazione!;
      });
  }

  getImage(): any {
    if(this.homePageHeaderFooter){
      return this.homePageHeaderFooter.Footer.Municipality.Logo
    }else if(this.configurazione?.logo) {
      const imageUrl = "data:image/png;base64," + this.configurazione?.logo;
      this.logoImage = this.sanitizer.bypassSecurityTrustResourceUrl(imageUrl);
      return this.logoImage;
    }
    return ''
  }

  goToHome(): void {
    if(this.homePageHeaderFooter){
      window.location.href = this.homePageHeaderFooter.BaseURLSito;
    }else{
      window.location.href = this.confService.configurazione.linkHome;
    }
  }
}
